<template>
  <div class="mChart">
    <div class="mChart">
      <div ref="mChart" class="mChart" v-if="showChart"></div>
    </div>
    <div v-if="!optionData.series.length || !optionData.series[0].data.length"
         class="tip">
      <el-empty :image-size="80" style="margin-top: 50px;" :description="' '"></el-empty>
    </div>
    <div class="tip2" :style="tipStyle"
         v-if="optionData.xAxis && optionData.xAxis.data && optionData.xAxis.data.length>optionData.dataZoom[0].endValue+1">
      数据过多【左右拖动查看】
    </div>
    <div class="tip3" v-if="showTip3">
      (访问设备：PC)
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'

export default {
  name: "mChart",
  props: {
    optionData: {
      type: Object,
      default: () => ({})
    },
    tipStyle: {
      type: Object,
      default: () => ({})
    },
    showTip3: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    optionData: {
      handler() {
        this.initData()
      },
      deep: true
    }
  },
  data() {
    return {
      showChart: true
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    initData() {
      this.showChart = false
      this.$nextTick(() => {
        this.showChart = true
        this.$nextTick(() => {
          this.myChart = echarts.init(this.$refs.mChart)
          this.myChart.setOption(this.optionData)
          window.addEventListener("resize", () => this.myChart.resize())
        })
      })
    }
  },
}
</script>

<style scoped lang="scss">
.mChart {
  width: 100%;
  height: 100%;
  position: relative;

  .tip {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
  }

  .tip2 {
    position: absolute;
    z-index: 0;
    top: 12%;
    right: 12%;
    color: rgba(204, 204, 204, 1);
    font-size: 12px;
  }
  .tip3 {
    position: absolute;
    z-index: 0;
    top: 12%;
    left: 290px;
    color: red;
    font-size: 12px;
  }
}


</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/new_account_settings/accountSettings/overallStatistics/components/mChart.vue